import * as React from 'react';

export const useTimeout = (cb: () => void, delay: number) => {
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      cb();
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
};
